import './js/support-ukraine/support-ukraine';
import './js/authorization-modal/authorization-modal';
import './js/home/home';
import './js/spinner/spinner';
import './js/scroll-up/scroll-up';
import './js/category/category';
import './js/burger-menu/burger-menu';
import './js/header/checkbox';
import './js/category/renderCatdListByCategory';
import './js/category/updateTitle';
import './js/home/renderBestSellersBooks';